import PopUpOnlineQuote from "./PopUpOnlineQuote";

export const onlineQuotesContent = (
  <>
    <div className='font-bold text-xl'>
      To generate a NO OBLIGATION online quote, please click on "Get Your Quote".
      Here at Insurance Enterprise USA, we provide TRUE AFFORDABLE health insurance.
      {/* We accomplish this by providing policies that are subject to underwriting approval. */}
      {/* <span className='text-error'> Submit your application by the 15th of the month to have an effective date of the 1st on the following month</span> */}
    </div>
    <div>
      <PopUpOnlineQuote />
    </div>

  </>
)